import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useZendeskChatIntegrationAutoSetupMutation } from 'src/services';
import { useNotification } from 'src/hooks/useNotification';
import { IntegrationZendeskChatAutoSetup } from 'src/components/Integrations/IntegrationAutoSetupPopup/IntegrationZendeskChatAutoSetup/IntegrationZendeskChatAutoSetup';
import { useAppSelector } from 'src/store';
import type { ZendeskChatAutoSetupData } from 'src/components/Integrations/IntegrationAutoSetupPopup/IntegrationZendeskChatAutoSetup/IntegrationZendeskChatAutoSetup';
import { useLoaderWhile } from 'src/hooks/useLoaderWhile';

export const ZendeskChatStep4 = ({
  onClose = () => {},
}: {
  onClose?: (isFinal?: boolean) => void;
}) => {
  const { id } = useParams();
  const notification = useNotification();
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const [
    setZendeskChatAutoSetup,
    { isSuccess: isSetZendeskChatAutoSetup, isLoading: isLoadingSetZendeskChatAutoSetup },
  ] = useZendeskChatIntegrationAutoSetupMutation();

  useEffect(() => {
    if (isSetZendeskChatAutoSetup) {
      notification.success('Integration Updated.');
      onClose(true);
    }
  }, [isSetZendeskChatAutoSetup]);

  useLoaderWhile(isLoadingSetZendeskChatAutoSetup);

  const submitChat = async (formData: ZendeskChatAutoSetupData) => {
    setZendeskChatAutoSetup({
      projectId: id,
      integrationId: formData.integrationId,
      body: formData,
    });
  };

  return (
    <IntegrationZendeskChatAutoSetup integration={selectedIntegration} onSubmit={submitChat} />
  );
};
